import {atom} from 'jotai'
import {atomWithReset} from 'jotai/utils'
import {createListResponseSchema} from 'src/feature/bite/domain'
import {
  ActivityItemList,
  ActivityListFilter,
  PurchaseItemList,
  PurchaseListFilter,
} from 'src/feature/transaction-list/domain'
import * as z from 'zod'
import {ListFilter, ListerFilterPackage, ListerFilterTrx, MemberList} from '../domain'

const list: MemberList = {
  dataList: [],
  paging: {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  },
}

export const listAtom = atom<MemberList>(list)

export const listFilterAtom = atomWithReset<ListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedDate'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterTrxAtom = atom<ListerFilterTrx>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedDate'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterPackageAtom = atom<ListerFilterPackage>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedDate'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterActivitiesAtom = atom<ListerFilterPackage>({
  filterList: [],
  orderList: [{type: 2, key: 'crtdOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterMarketingAtom = atom<ListerFilterTrx>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedDate'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

const activityList: ActivityItemList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 1,
    pageSize: 1,
    totalCount: 1,
  },
}

export const activityListAtom = atom<ActivityItemList>(activityList)
export const activityListFilterAtom = atom<ActivityListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'Date'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  search: {
    value: '',
    keyList: [],
  },
})

const purchaseList: PurchaseItemList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 1,
    pageSize: 1,
    totalCount: 1,
  },
}

export const purchaseListAtom = atom<PurchaseItemList>(purchaseList)
export const purchaseListFilterAtom = atom<PurchaseListFilter>({
  filterList: [],
  orderList: [{type: 2, key: 'crtdOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  search: {
    value: '',
    keyList: [],
  },
})

export const PurchaseListItemSchema = z.object({
  memberId: z.string(),
  fullName: z.string(),
  status: z.number(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
  id: z.string().nullable(),
})
export const PurchaseListSchemaResponse = createListResponseSchema(PurchaseListItemSchema.array())

export type PurchaseListItem = z.infer<typeof PurchaseListItemSchema>
export type PurchaseList = z.infer<typeof PurchaseListSchemaResponse.shape.response>
export type PurchaseListResponse = z.infer<typeof PurchaseListSchemaResponse>
